export default "__VITE_ASSET__Bd56VNw$__"